<template>
  <div class="product-media-layout">
    <div
      ref="currentImageRef"
      class="product-media__current"
    >
      <ScrollAdjustmentWrapper>
        <CurrentImageMedia
          v-if="isImageMedia(currentMedia)"
          :current-media="currentMedia"
        />

        <CurrentVideoMedia
          v-else-if="isVideoMedia(currentMedia)"
          :media="currentMedia"
        />
      </ScrollAdjustmentWrapper>

      <div
        v-if="mediaList.length > 1"
        class="product-media-pages-indicator-wrapper"
      >
        <MediaPagesIndicator
          class="product-media__pages-indicator"
          :pages-count="mediaList.length"
          :current-page="currentMediaIndex"
          @select-page="selectMedia"
        />
      </div>
    </div>

    <ProductMediaList
      v-if="mediaList.length > 1"
      :media-list="mediaList"
      :current-image-el="currentImageRef"
      :current-media-index="currentMediaIndex"
      @select-media="selectMedia"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref, Ref, computed } from 'vue';

  import CurrentVideoMedia from '../media/CurrentVideoMedia.vue';
  import { Product, StrapiProductMedia } from '@/services/product/types';
  import CurrentImageMedia from '../media/CurrentImageMedia.vue';
  import ProductMediaList from '../media/ProductMediaList.vue';
  import { isImageMedia, isVideoMedia } from '@/services/product/helpers';
  import MediaPagesIndicator from '../media/inner/MediaPagesIndicator.vue';
  import ScrollAdjustmentWrapper from '../ScrollAdjustmentWrapper.vue';

  const props = defineProps<{
    product: Product;
  }>();

  const mediaList: Ref<StrapiProductMedia[]> = computed(() => props.product.attributes.medias);

  const currentMediaIndex = ref(mediaList.value.findIndex(media => media.is_main));
  if (currentMediaIndex.value === -1) {
    currentMediaIndex.value = 0;
  }

  const currentImageRef = ref<HTMLElement | null>(null);

  const currentMedia = computed(() => mediaList.value[currentMediaIndex.value]);

  const selectMedia = (index: number) => {
    currentMediaIndex.value = index;
  };
</script>

<style scoped>
  .product-media-layout {
    display: flex;
    align-items: flex-start;
    gap: 18px;
    padding: 0 37px;
  }

  .product-media__current {
    flex-grow: 1;
    position: relative;
    align-self: stretch;
    border-radius: 18px;
    border: 3px solid #e5e5e5;
    overflow: hidden;
  }

  .product-media-pages-indicator-wrapper {
    position: absolute;
    bottom: 0;
    top: 0;
    margin: auto 0;
    right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product-media__pages-indicator {
  }

  @media (--mobile) {
    .product-media-layout {
      width: 100%;
      margin-left: 0;
      flex-direction: column;
      padding: 0 0;
    }

    .product-media__current {
      width: 100%;
    }
    .product-media-pages-indicator-wrapper {
      position: absolute;
      bottom: 4px;
      top: auto;
      margin: auto 0;
      right: 0;
      left: 0;
    }
  }
</style>
